import type { ReactElement, FC } from 'react';
import { Box } from 'braid-design-system';
import DetailsTabView from './DetailsTabView/DetailsTabView';
import type { IJobApplication } from '../../../stores/JobApplicationStore/JobApplication';
import { observer } from 'mobx-react';
import HeaderSection from './HeaderSection';
import * as styles from './DetailsContentView.css';
import type { EmployerLocale } from 'src/siteConfig';
import { TRACKING_CANDIDATE_DETAILS } from 'src/constants/pageTrackingData';

interface Props {
  jobApplication: IJobApplication;
  isMobile: boolean;
  children: ReactElement;
  locale: EmployerLocale;
  questionnaireId?: string;
}
const DetailsContentView: FC<Props> = ({
  jobApplication,
  isMobile,
  children,
  locale,
  questionnaireId,
}: Props) => {
  const onClickRating = (selectedRatingValue: number): number => {
    if (selectedRatingValue === jobApplication.rating.rating) {
      const newRatingValue = 0;
      jobApplication.rating.updateRating(0, TRACKING_CANDIDATE_DETAILS);
      return newRatingValue;
    }
    jobApplication.rating.updateRating(
      selectedRatingValue,
      TRACKING_CANDIDATE_DETAILS,
    );
    return selectedRatingValue;
  };

  return (
    <Box background="surface" className={styles.cardContainer}>
      <HeaderSection
        candidateId={jobApplication.candidateId}
        jobApplicationId={jobApplication.id}
        fullName={jobApplication.fullName}
        email={jobApplication.email}
        phone={jobApplication.phone}
        rating={jobApplication.rating.rating}
        onClickRating={onClickRating}
        isMobile={isMobile}
        locale={locale}
        homeLocation={jobApplication.profile?.homeLocation?.description ?? ''}
        billableStatus={jobApplication.billableStatus ?? ''}
        appliedDate={jobApplication.appliedDate}
        source={jobApplication.source}
      >
        {children}
      </HeaderSection>
      <Box className={styles.cardContainer}>
        <DetailsTabView
          jobApplication={jobApplication}
          isMobile={isMobile}
          locale={locale}
          questionnaireId={questionnaireId}
        />
      </Box>
    </Box>
  );
};
export default observer(DetailsContentView);
